const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

export const isRtlLanguage = (languageIso2: string): boolean =>
  RTL_LANGUAGES.includes(languageIso2?.toLowerCase());

export const getDirection = (languageIso2: string): 'rtl' | 'ltr' =>
  isRtlLanguage(languageIso2) ? 'rtl' : 'ltr';